import { atom } from "jotai";

export const isStoppingAtom = atom(false);